import React, {Component} from 'react';
import {connect} from 'react-redux';
import Typekit from 'react-typekit';

import {fetchPost} from '../actions/index';

import Header from '../components/header';
import Main from '../components/main';
import NavBar from './parts/NavBar';
import PageNav from '../containers/parts/page-nav';


class Single extends Component {
    componentWillMount() {
        this.props.fetchPost(this.props.location.pathname);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.location.pathname !== nextProps.location.pathname) {
            this.props.fetchPost(nextProps.location.pathname);
        }
    }

    componentDidUpdate() {
        document.title = `${RT_API.siteName} - ${RT_API.siteDescription}`;;
    }

    render() {
        return (
            <div>
	            <section className="kiosk-wrapper template-single">
	                <Typekit kitId="eab1tpm" />
	                <Header/>
	                <Main />
	                <NavBar name="footer_menu"/>
	            </section>
            </div>
        );
    }
}


function mapStateToProps({posts}) {
    return {posts};
}

export default connect(mapStateToProps, {fetchPost})(Single)


// WEBPACK FOOTER //
// ./src/containers/single.js